export const createNumberRangeArray = (start, end) => {
  return Array.from(Array(end - start + 1), (_, i) => i + start)
}
